module.exports = __webpack_public_path__ + "media/images/logo_big-29d5411c133c7c1a8e00a8ad900941e2.png";